import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useToast } from '../../components/ui/ToastProvider';
import { useLanguage } from '../../contexts/LanguageContext';
import SupplierNavbar from '../../components/supplier/SupplierNavbar';
import SupplierArticleList from '../../components/supplier/SupplierArticleList';
import api from '../../services/api';

const SupplierArticles: React.FC = () => {
  const { masterToken } = useParams<{ masterToken: string }>();
  const navigate = useNavigate();
  const { showError } = useToast();
  const { t } = useLanguage();

  // Core States
  const [loading, setLoading] = useState(true);
  const [supplierInfo, setSupplierInfo] = useState<any>(null);
  const [activeAuctions, setActiveAuctions] = useState(0);

  useEffect(() => {
    const loadSupplierData = async () => {
      if (!masterToken) {
        showError('Ungültiger Zugang');
        navigate('/supplier/portal');
        return;
      }

      try {
        setLoading(true);
        
        // Get supplier info from session storage or make API call
        const supplierSession = sessionStorage.getItem('supplierPortalSession');
        if (supplierSession) {
          // For now, set basic supplier info
          setSupplierInfo({ name: 'Lieferant' });
        } else {
          showError('Session abgelaufen');
          navigate('/supplier/portal');
          return;
        }
      } catch (error) {
        console.error('Error loading supplier data:', error);
        showError('Verbindungsfehler');
        navigate('/supplier/portal');
      } finally {
        setLoading(false);
      }
    };

    loadSupplierData();
    loadAuctionStats();
  }, [masterToken, navigate, showError]);

  const loadAuctionStats = async () => {
    try {
      const response = await api.get('/supplier-portal/auctions/stats');
      setActiveAuctions(response.data.activeAuctions || 0);
    } catch (error) {
      console.log('⚠️ Could not load auction stats');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Laden...</p>
        </div>
      </div>
    );
  }

  if (!supplierInfo) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600">Fehler beim Laden der Supplier-Informationen</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <SupplierNavbar 
        supplierName={supplierInfo?.name || 'Lieferant'} 
        masterToken={masterToken}
        pendingQuestionnaires={0}
        totalArticles={0}
        activeAuctions={activeAuctions}
      />
      
      {/* Use the SupplierArticleList component with table layout */}
      <SupplierArticleList />
    </div>
  );
};

export default SupplierArticles;